import { useTheme } from "@mui/material/styles";
import { Routes, Route, Navigate } from "react-router-dom";
import { Container, Box } from "@mui/material";
import { useState } from "react";

import ModernSidebar from "../layout/ModernSidebar";
import ModernAppBar from "./ModernAppBar";
import MobileDrawer from "./MobileDrawer";

import AdminManager from "../AdminManager";
import AdminListItemsInterface from "../../interfaces/AdminListItemsInterface";
import AdminItemInterface from "../../interfaces/AdminItemInterface";
import AdminMerchantInterface from "../../interfaces/AdminMerchantInterface";
import AdminMerchantsInterface from "../../interfaces/AdminMerchantsInterface";
import AdminCategoryInterface from "../../interfaces/AdminCategoryInterface";
import AdminCategoriesInterface from "../../interfaces/AdminCategoriesInterface";
import AdminSalesInterface from "../../interfaces/AdminSalesInterface";
import AdminSaleInterface from "../../interfaces/AdminSaleInterface";
import AdminFormsInterface from "../../interfaces/AdminFormsInterface";
import AdminFormStatsInterface from "../../interfaces/AdminFormStatsInterface";
import AdminSalesStatsInterface from "../../interfaces/AdminSalesStatsInterface";
import AdminPaymentInterface from "../../interfaces/AdminPaymentInterface";
import AdminPaymentsInterface from "../../interfaces/AdminPaymentsInterface";
import AdminCustomersInterface from "../../interfaces/AdminCustomersInterface";
import AdminTicketsInterface from "../../interfaces/AdminTicketsInterface";
import AdminUsersInterface from "../../interfaces/AdminUsersInterface";
import AdminCustomersStatsInterface from "../../interfaces/AdminCustomersStatsInterface";
import AdminHelperManager from "../AdminHelperManager";
import AdminDashboard from "../AdminDashboard";
import ModernDashboard from "../ModernDashboard";
import AdminProfileInterface from "../../interfaces/AdminProfileInterface";
import AdminLogout from "../AdminLogout";
import AdminManualTicketInterface from "../../interfaces/AdminManualTicketInterface";
import AdminTicketInterface from "../../interfaces/AdminTicketInterface";
import AdminSMSInterface from "../../interfaces/AdminSMSInterface";
import AdminListSMSInterface from "../../interfaces/AdminListSMSInterface";
import AdminPartnerInterface from "../../interfaces/AdminPartnerInterface";
import AdminListPartnersInterface from "../../interfaces/AdminListPartnersInterface";
import AdminBlogInterface from "../../interfaces/AdminBlogInterface";
import AdminListBlogsInterface from "../../interfaces/AdminListBlogsInterface";
import AdminLogsInterface from "../../interfaces/AdminLogsInterface";
import AdminFormInterface from "../../interfaces/AdminFormInterface";
import NotFound from "../NotFound";

const localUser = JSON.parse(localStorage.getItem("kdmUser"));
const superUser = localUser?.sub === process.env.REACT_APP_ADMIN_UID;

// Styles à appliquer via l'objet de style
const styles = (theme) => ({
  root: {
    height: "100vh",
    overflow: "hidden",
  },
  wrapperStyle: {
    display: "flex",
    flexDirection: "row",
  },

  containerStyle: {
    height: "100vh",
    overflow: "overlay",
    padding: "0 0 140px 0",
  },
});

const AdminMenu = () => {
  const theme = useTheme();
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      <ModernAppBar onMenuClick={handleDrawerToggle} />
      <MobileDrawer open={mobileOpen} onClose={handleDrawerToggle} />
      <Box sx={{ display: "flex", flex: 1 }}>
        <ModernSidebar />
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: { xs: 2, md: 3 },
            backgroundColor: "background.default",
            minHeight: "calc(100vh - 64px)",
          }}
        >
          <Container maxWidth="xl" sx={{ py: { xs: 1, md: 2 } }}>
            <Routes>
              <Route
                path="/items"
                element={
                  <AdminManager
                    type="items"
                    labelAddItem="Ajouter un article"
                    breadcrumTitle="Gestion des articles"
                    EditComponent={AdminItemInterface}
                    ListComponent={AdminListItemsInterface}
                    CustomComponent={AdminManualTicketInterface}
                    labelCustomComponent={"Générer un ticket"}
                  />
                }
              />
              <Route
                path="/merchants"
                element={
                  <AdminManager
                    type="merchants"
                    labelAddItem="Ajouter un point de vente"
                    breadcrumTitle="Gestion des marchants"
                    EditComponent={AdminMerchantInterface}
                    ListComponent={AdminMerchantsInterface}
                  />
                }
              />
              <Route
                path="/categories"
                element={
                  <AdminManager
                    type="categories"
                    labelAddItem="Ajouter un menu"
                    breadcrumTitle="Gestion des menus"
                    EditComponent={AdminCategoryInterface}
                    ListComponent={AdminCategoriesInterface}
                  />
                }
              />
              <Route
                path="/sales/:saleId?"
                element={
                  <AdminManager
                    type="sales"
                    labelAddItem="Ajouter une vente"
                    breadcrumTitle="Gestion des ventes"
                    EditComponent={AdminSaleInterface}
                    ListComponent={AdminSalesInterface}
                  />
                }
              />
              <Route
                path="/sales-stats"
                element={<AdminSalesStatsInterface />}
              />
              <Route
                path="/payments"
                element={
                  <AdminManager
                    type="payments"
                    labelAddItem="Ajouter un paiement"
                    breadcrumTitle="Gestion des paiements"
                    EditComponent={AdminPaymentInterface}
                    ListComponent={AdminPaymentsInterface}
                  />
                }
              />
              <Route
                path="/customers"
                element={
                  <AdminManager
                    type="customers"
                    labelAddItem="Ajouter un client"
                    breadcrumTitle="Gestion des clients"
                    EditComponent={null}
                    ListComponent={AdminCustomersInterface}
                  />
                }
              />
              <Route
                path="/tickets/:ticketCode?"
                element={
                  <AdminManager
                    type="tickets"
                    labelAddItem="Ajouter un ticket"
                    breadcrumTitle="Gestion des tickets générés"
                    EditComponent={AdminTicketInterface}
                    ListComponent={AdminTicketsInterface}
                  />
                }
              />
              <Route
                path="/formalyze"
                element={
                  <AdminManager
                    type="formalyze"
                    labelAddItem="Ajouter un formulaire"
                    breadcrumTitle="Gestion des formulaires"
                    EditComponent={AdminFormInterface}
                    ListComponent={AdminFormsInterface}
                  />
                }
              />
              <Route path="/form-stats" element={<AdminFormStatsInterface />} />
              <Route
                path="/sms"
                element={
                  <AdminManager
                    type="sms"
                    labelAddItem="Créer une campagne SMS"
                    breadcrumTitle="Gestion des campagnes SMS"
                    EditComponent={AdminSMSInterface}
                    ListComponent={AdminListSMSInterface}
                  />
                }
              />
              <Route
                path="/partners"
                element={
                  <AdminManager
                    type="partners"
                    labelAddItem="Ajouter un partenaire"
                    breadcrumTitle="Gestion des partenaires"
                    EditComponent={AdminPartnerInterface}
                    ListComponent={AdminListPartnersInterface}
                  />
                }
              />
              <Route
                path="/articles"
                element={
                  <AdminManager
                    type="blogs"
                    labelAddItem="Ajouter un article de blog"
                    breadcrumTitle="Gestion des articles de blog"
                    EditComponent={AdminBlogInterface}
                    ListComponent={AdminListBlogsInterface}
                  />
                }
              />
              {superUser && (
                <Route
                  path="/users"
                  element={
                    <AdminManager
                      type="users"
                      labelAddItem="Ajouter un utilisateur"
                      EditComponent={() => {}}
                      ListComponent={AdminUsersInterface}
                    />
                  }
                />
              )}
              <Route path="/logs" element={<AdminLogsInterface />} />
              <Route
                path="/customers-stats"
                element={<AdminCustomersStatsInterface />}
              />
              <Route path="/helper" element={<AdminHelperManager />} />
              <Route path="/profile" element={<AdminProfileInterface />} />
              <Route path="/logout" element={<AdminLogout />} />
              <Route path="/dashboard" element={<ModernDashboard />} />
              <Route path="/" element={<ModernDashboard />} />
              <Route path="/login" element={<Navigate to="/" replace />} />
              <Route path="/register" element={<Navigate to="/" replace />} />
              <Route
                path="/recover-password"
                element={<Navigate to="/" replace />}
              />
              <Route path="/verify" element={<Navigate to="/" replace />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Container>
        </Box>
      </Box>
    </Box>
  );
};

export default AdminMenu;
